export default __webpack_public_path__ + "static/media/DSC_0544.462090a0.webp";